import { Input } from "@workspace/web-ui/components/input"
import { cn } from "@workspace/web-ui/lib/utils"
import { Search } from "lucide-react"

interface SearchInputProps {
    value: string
    setValue: (value: string) => void
    placeholder?: string
    className?: string
}

export const SearchInput = ({ value, setValue, placeholder, className }: SearchInputProps) => {
    return (
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg border border-[#ADACB0] w-full bg-white md:w-[28rem]">
            <Search className="w-5 h-5" />
            <Input
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={placeholder}
                className={cn("border-none w-full outline-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-none focus-visible:outline-none h-fit", className)}
            />
        </div>
    )
}

